import { render, staticRenderFns } from "./ErrorMessageUserContainer.vue?vue&type=template&id=b96a455a&scoped=true&"
import script from "./ErrorMessageUserContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageUserContainer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageUserContainer.vue?vue&type=style&index=0&id=b96a455a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96a455a",
  null
  
)

export default component.exports